import { HOTJAR_SITE_ID, PROD } from '@config/env'
import Hotjar from '@hotjar/browser'

const hotjarVersion = 6

if (PROD) {
  Hotjar.init(HOTJAR_SITE_ID, hotjarVersion)
}
